export function getWhatsappLink() {
    const split = (this.settings.whatsapp_numbers || '').split(',').map(string => string.trim());
    const number = _.sample(split);

    return `https://wa.me/${number}`;
}
